<template>
    <div>
        <modal :show="show">
            <div class="modal-body">

                <div class="row">
                    <div class="form-group col-md-12">
                        <label>Reason</label>
                        <textarea v-model="reason" type="text" class="form-control"></textarea>
                    </div>
                </div>

            </div>
            <div class="modal-footer bg-light" >
                <button type="button" class="btn btn-primary btn-round" v-on:click="SaveFund()">Submit</button>
                <button type="button" class="btn btn-danger btn-round" v-on:click="close()">Cancel</button>
            </div>
        </modal>

    </div>
</template>
<script>

    export default {
        props: ['show', ],
        data: function () {
            return {
                reason: '',
            }
        },
        methods: {

            SaveFund: function () {
                this.$emit('Save', this.reason);
                
            },

            close: function () {
                this.$emit('close');
            }
        },

        created: function () {           


        },
        mounted: function () {

        },

    }
</script>